import { createClient } from '@connectrpc/connect';
import { connectTransport } from '@mono/ui-runtime/connect';
import { OpportunityWatchService } from '../../../../../../gen/ts/mono/morgans/v1/opportunity_watch_connect';
export const watchClient = createClient(OpportunityWatchService, connectTransport);
